import React from 'react';
import {
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { Box } from '@mui/material';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { dataAttrs } from 'Helpers/Testing';
import InfoBox from 'Views/Onboarding/Components/InfoBox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';

function MeetingPreparationSection() {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <InfoBox>
      <FDStack padding={3} direction={'column'} spacing={2} {...dataAttrs('meeting-preparation-section')}>
        <MetaControlField attr={'title'} simpleRootStyle />
        <MetaControlField attr={'subtitle'} simpleRootStyle />
        {resource.attr('checklistItems') && resource.attr('checklistItems').length > 0
          ? (
            <Box sx={{ border: '1px solid #DADADA', borderRadius: '8px', padding: '24px 16px' }}>
              <FDStack direction={'column'} spacing={2}>
                {resource.attr('checklistItems').map((item) => {
                  return (
                    <FDStack direction={'row'} spacing={2} {...dataAttrs('meeting-preparation-checklist-item')}>
                      <Icon
                        fill={'secondary'}
                        icon={CheckCircleIcon}
                      />
                      <Text value={item} weight={'medium'} color={'primaryGray'} variant={'h6'} align={'left'} />
                    </FDStack>);
                })}
              </FDStack>
            </Box>)
          : null
          }
      </FDStack>
    </InfoBox>
  );
}

MeetingPreparationSection.propTypes = {
};

MeetingPreparationSection.defaultProps = {
};

export default MeetingPreparationSection;
